import { useEffect } from 'react';
import { Hide } from '@qga/roo-ui/components';
import * as Sentry from '@sentry/nextjs';

import { AuthProvider } from '@shared/v2/components/AuthContext';
import useOptimizelyAnalytics from '@shared/v2/hooks/useOptimizelyAnalytics';
import { getUserUuid } from '@shared/v2/utils/getUserUuid';

import AbandonCart from '@/components/AbandonCart';
import DocumentTitle from '@/components/DocumentTitle';
import GlobalPreviewIndicator from '@/components/GlobalPreviewIndicator';
import Providers from '@/components/Providers';
import SimplicityHeader from '@/components/SimplicityHeader';
import SWRProvider from '@/components/SWRProvider';
import { WebChatProvider } from '@/components/WebChat';
import {
  AUTH_API_URL,
  LSL_AUTH_URL,
  LSL_USERNAME,
  REDIRECT_URL,
} from '@/config/public';
import SiteMessage from '@/v2/components/ui/SiteMessage';
import { FEATURE_FLAGS_FOR_ANALYTICS } from '@/v2/constants/featureFlags';
import dataLayer from '@/v2/utils/dataLayer';
import Ciutadella from './components/Ciutadella';

const App = ({ Component, pageProps }) => {
  useOptimizelyAnalytics({
    featureFlagsForAnalytics: FEATURE_FLAGS_FOR_ANALYTICS,
    dataLayer,
  });

  useEffect(() => {
    const userUuid = getUserUuid();
    if (userUuid) {
      Sentry.setUser({ id: userUuid });
    }
  }, []);

  const warningMessage =
    pageProps?.warningMessage || pageProps?.app?.warningMessage;

  return (
    <>
      <DocumentTitle />
      <Ciutadella />
      <SWRProvider>
        <Providers>
          <WebChatProvider>
            <AuthProvider
              dataLayer={dataLayer}
              config={{
                clientId: LSL_USERNAME,
                qffAuthApiUrl: AUTH_API_URL,
                lslAuthApiUrl: LSL_AUTH_URL,
                redirectUri: REDIRECT_URL,
                client: 'qhp',
              }}
            >
              <GlobalPreviewIndicator />
              <SiteMessage siteMessage={warningMessage} variant="warning" />
              <Hide xs sm>
                <SimplicityHeader />
              </Hide>
              <Component {...pageProps} />
              <AbandonCart />
            </AuthProvider>
          </WebChatProvider>
        </Providers>
      </SWRProvider>
    </>
  );
};

export default App;
